import { create } from 'zustand';

type GlobalSearchStore = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};

const useGlobalSearchStore = create<GlobalSearchStore>(set => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));

export { useGlobalSearchStore };
